<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="新建"
      class="material-edit"
      width="500px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="material"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-row>
        <el-col :span="18">
          <el-form-item label="成品" prop="materialFinished">
            <el-input v-model="material.materialFinished" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="半成品" prop="materialFinishedSemi">
            <el-input v-model="material.materialFinishedSemi" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "SemiFinishedProductsEdit",
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        action: window.config.basicServerUrl + "files/upload/software",
        fileList: [],
        material: {
          pkid: 0,
          materialFinished: "",
          materialFinishedSemi: "",
        },
        ruleValidate: {
          materialFinished: {required: true, message: "不能为空",trigger: "blur"},
          materialFinishedSemi: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.material.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `material/${this.material.pkid}`)
          .then(resp => {
            this.material = resp;
          });
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "material", this.material)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
